"use client";

/**
 * MetricStatGridWidget — compact desk readouts (positions count, orders, etc.).
 */
import React from "react";
import { Skeleton } from "antd";
import { DeskButton, DeskReadout } from "@/shared/components/desk";
import type { DeskMetricItem } from "./lib/types";
import local from "./MetricStatGridWidget.module.css";

export interface MetricStatGridWidgetProps {
  items: DeskMetricItem[];
  "aria-label"?: string;
  className?: string;
}

export function MetricStatGridWidget({
  items,
  "aria-label": ariaLabel = "Desk metrics",
  className = "",
}: MetricStatGridWidgetProps) {
  return (
    <section
      className={`${local.grid} ${className}`.trim()}
      aria-label={ariaLabel}
    >
      {items.map((item) => (
        <article key={item.key} className={local.card}>
          {item.loading ? (
            <Skeleton active paragraph={{ rows: 1 }} title={false} />
          ) : (
            <>
              <DeskReadout
                label={item.label}
                value={item.value}
                empty={item.empty}
                hint={item.meta}
              />
              {item.actionLabel && item.onAction ? (
                <DeskButton type="link" onClick={item.onAction}>
                  {item.actionLabel}
                </DeskButton>
              ) : null}
            </>
          )}
        </article>
      ))}
    </section>
  );
}
